import { animate, useInView, useMotionValue, useTransform } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import { EASE_OUT } from '../constants';

export function AnimatedNumber({ target, duration = 2.5, suffix = '', prefix = '', className }: { target: number; duration?: number; suffix?: string; prefix?: string; className?: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });
  const motionVal = useMotionValue(0);
  const rounded = useTransform(motionVal, (v) => {
    if (v >= 1_000_000) {
      const millions = v / 1_000_000;
      return millions >= target / 1_000_000 ? `${Math.round(millions)}` : `${millions.toFixed(1)}`;
    }
    if (v >= 1_000) return Math.round(v).toLocaleString();
    return Math.round(v).toString();
  });
  const [display, setDisplay] = useState('0');

  useEffect(() => {
    const unsub = rounded.on('change', setDisplay);
    return unsub;
  }, [rounded]);

  useEffect(() => {
    if (!inView) return undefined;
    const controls = animate(motionVal, target, {
      duration,
      ease: EASE_OUT as unknown as [number, number, number, number],
    });
    return controls.stop;
  }, [inView, motionVal, target, duration]);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
}
